module.exports = __webpack_public_path__ + "img/backpack.9d736d26.png";